import { PendingJobsSection } from "@/components/PendingJobsSection";
import { AwaitingDeliverySection } from "@/components/AwaitingDeliverySection";
import { CompletedJobsSection } from "@/components/CompletedJobsSection";
import { DashboardStatsStrip } from "./DashboardStatsStrip";
import { JobLimitWarning } from "@/components/JobLimitWarning";
import { SetupCentreCard } from "@/components/onboarding/SetupCentreCard";
import { OnboardingLauncher } from "@/components/onboarding/OnboardingLauncher";
import { PageHeader } from "@/components/ui/page-header";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import { useNavigate } from "react-router-dom";

export function DesktopAdminDashboard() {
  const navigate = useNavigate();
  return (
    <div className="mx-auto max-w-7xl space-y-6">
      <PageHeader
        title="Dashboard"
        description="Overview of active jobs, deliveries, and completed work"
        actions={<Button onClick={() => navigate("/create-job")}><Plus />Create Job</Button>}
      />

      <JobLimitWarning />
      <SetupCentreCard />
      <OnboardingLauncher />
      <DashboardStatsStrip />

      <AwaitingDeliverySection />
      <PendingJobsSection />
      <CompletedJobsSection />
    </div>
  );
}
